<script lang="ts" setup>
import { computed } from 'vue'
import LocaleLink from '@/components/base/LocaleLink.vue'

// The withdrawal note and the consent of § 356 Abs. 4 BGB for an upgrade or a
// switch from the free tier, between the price block and the button. The box
// starts unticked; the dialog keeps its button disabled until it is ticked.
// chargedLater: the upgrade charges nothing today; its next invoice does.
const props = defineProps<{ modelValue: boolean; freeToPaid?: boolean; chargedLater?: boolean }>()
const emit = defineEmits<{ (e: 'update:modelValue', value: boolean): void }>()

const note = computed(() => {
  if (props.freeToPaid) return 'common.termSwitch.switchWithdrawalNoteFreeToPaid'
  return props.chargedLater ? 'common.termSwitch.switchWithdrawalNoteNextInvoice' : 'common.termSwitch.switchWithdrawalNote'
})
</script>

<template>
  <div class="switch-withdrawal">
    <i18n-t
      :keypath="note"
      tag="p"
      class="switch-withdrawal-note"
    >
      <template #link>
        <LocaleLink to="withdrawal" target="_blank" class="switch-withdrawal-link">{{ $t('common.termSwitch.switchWithdrawalLink') }}</LocaleLink>
      </template>
    </i18n-t>
    <label class="switch-withdrawal-consent">
      <input
        type="checkbox"
        data-test="switch-consent"
        :checked="modelValue"
        @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
      />
      <span>{{ $t('common.termSwitch.switchWithdrawalConsent') }}</span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.switch-withdrawal {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 0.8rem;
  line-height: 1.5;
  color: rgba(200, 218, 255, 0.75);
}

.switch-withdrawal-note {
  margin: 0;
}

.switch-withdrawal-link {
  color: #4fc3f7;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.switch-withdrawal-consent {
  display: flex;
  gap: 8px;
  cursor: pointer;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    margin-top: 2px;
    accent-color: #00b0ff;
    flex-shrink: 0;
  }
}

.v-theme--lightTheme .switch-withdrawal {
  color: rgba(15, 23, 42, 0.75);
}
</style>
